import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAddToAList = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_iii_38213_5398)",
			children: [/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter1_diii_38213_5398)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M14.5317 5.53772H32.3329C32.5981 5.53772 32.8524 5.64308 33.04 5.83061L48.4624 21.2531C48.65 21.4406 48.7553 21.695 48.7553 21.9602V47.9838C48.7553 51.3327 46.0514 54.0475 42.7158 54.0475H14.5317C11.1962 54.0475 8.49219 51.3327 8.49219 47.9838V11.6014C8.49219 8.25254 11.1962 5.53772 14.5317 5.53772Z",
					fill: "url(#paint0_linear_38213_5398)"
				})
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#filter2_iii_38213_5398)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M32.748 7.82761C32.748 6.9367 33.8252 6.49053 34.4552 7.1205L47.0492 19.7145C47.6791 20.3445 47.233 21.4216 46.3421 21.4216H33.748C33.1958 21.4216 32.748 20.9739 32.748 20.4216V7.82761Z",
					fill: "url(#paint1_linear_38213_5398)"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.7533,
			cy: 46.3447,
			r: 6.99935,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("foreignObject", {
			x: 8.79922,
			y: 20.5111,
			width: 63.9094,
			height: 51.6669,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					backdropFilter: "blur(6.8px)",
					clipPath: "url(#bgblur_0_38213_5398_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter3_ii_38213_5398)",
			"data-figma-bg-blur-radius": 13.5914,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M59.0113 45.8488C58.9577 45.7279 57.6616 42.8526 54.7801 39.9711C50.9407 36.1317 46.0913 34.1025 40.7537 34.1025C35.4162 34.1025 30.5668 36.1317 26.7274 39.9711C23.8459 42.8526 22.5436 45.7325 22.4962 45.8488C22.4266 46.0054 22.3906 46.1748 22.3906 46.3461C22.3906 46.5175 22.4266 46.6869 22.4962 46.8435C22.5498 46.9644 23.8459 49.8382 26.7274 52.7197C30.5668 56.5576 35.4162 58.5867 40.7537 58.5867C46.0913 58.5867 50.9407 56.5576 54.7801 52.7197C57.6616 49.8382 58.9577 46.9644 59.0113 46.8435C59.0809 46.6869 59.1169 46.5175 59.1169 46.3461C59.1169 46.1748 59.0809 46.0054 59.0113 45.8488ZM40.7537 52.4657C39.5431 52.4657 38.3597 52.1067 37.3531 51.4341C36.3465 50.7615 35.5619 49.8055 35.0986 48.687C34.6353 47.5686 34.5141 46.3378 34.7503 45.1505C34.9865 43.9631 35.5695 42.8724 36.4255 42.0164C37.2816 41.1603 38.3722 40.5774 39.5596 40.3412C40.7469 40.105 41.9777 40.2262 43.0962 40.6895C44.2146 41.1528 45.1706 41.9373 45.8432 42.9439C46.5158 43.9505 46.8748 45.134 46.8748 46.3446C46.8748 47.968 46.2299 49.5249 45.082 50.6728C43.9341 51.8208 42.3771 52.4657 40.7537 52.4657Z",
				fill: "#A4BCF9",
				fillOpacity: .5
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_iii_38213_5398",
				x: 5.49219,
				y: -9.46228,
				width: 58.2637,
				height: 66.5098,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -3,
						dy: 3
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 7 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 15,
						dy: -15
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 13.5 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_38213_5398",
						result: "effect2_innerShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0.15254 0 0 0 0 0.406773 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_innerShadow_38213_5398",
						result: "effect3_innerShadow_38213_5398"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_diii_38213_5398",
				x: 3.49219,
				y: -3.64384,
				width: 54.4452,
				height: 66.6914,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feMorphology", {
						radius: 1,
						operator: "erode",
						in: "SourceAlpha",
						result: "effect1_dropShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 4 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_38213_5398",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -1.83631,
						dy: 1.83631
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4.28473 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect2_innerShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 9.18156,
						dy: -9.18156
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8.2634 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_innerShadow_38213_5398",
						result: "effect3_innerShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -.612104 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .612104 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0.15254 0 0 0 0 0.406773 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect3_innerShadow_38213_5398",
						result: "effect4_innerShadow_38213_5398"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_iii_38213_5398",
				x: 30.9117,
				y: -2.96804,
				width: 26.2257,
				height: 26.226,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: -1.83631,
						dy: 1.83631
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.83631 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 9.79366,
						dy: -9.79366
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 8.87551 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_38213_5398",
						result: "effect2_innerShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -1.83631 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .612104 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0.15254 0 0 0 0 0.406773 0 0 0 0.3 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_innerShadow_38213_5398",
						result: "effect3_innerShadow_38213_5398"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_ii_38213_5398",
				x: 8.79922,
				y: 20.5111,
				width: 63.9094,
				height: 51.6669,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -3 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.203922 0 0 0 0 0.498039 0 0 0 0 0.988235 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_38213_5398"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2,
						dy: 3
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_38213_5398",
						result: "effect2_innerShadow_38213_5398"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "bgblur_0_38213_5398_clip_path",
				transform: "translate(-8.79922 -20.5111)",
				children: /* @__PURE__ */ _jsx("path", { d: "M59.0113 45.8488C58.9577 45.7279 57.6616 42.8526 54.7801 39.9711C50.9407 36.1317 46.0913 34.1025 40.7537 34.1025C35.4162 34.1025 30.5668 36.1317 26.7274 39.9711C23.8459 42.8526 22.5436 45.7325 22.4962 45.8488C22.4266 46.0054 22.3906 46.1748 22.3906 46.3461C22.3906 46.5175 22.4266 46.6869 22.4962 46.8435C22.5498 46.9644 23.8459 49.8382 26.7274 52.7197C30.5668 56.5576 35.4162 58.5867 40.7537 58.5867C46.0913 58.5867 50.9407 56.5576 54.7801 52.7197C57.6616 49.8382 58.9577 46.9644 59.0113 46.8435C59.0809 46.6869 59.1169 46.5175 59.1169 46.3461C59.1169 46.1748 59.0809 46.0054 59.0113 45.8488ZM40.7537 52.4657C39.5431 52.4657 38.3597 52.1067 37.3531 51.4341C36.3465 50.7615 35.5619 49.8055 35.0986 48.687C34.6353 47.5686 34.5141 46.3378 34.7503 45.1505C34.9865 43.9631 35.5695 42.8724 36.4255 42.0164C37.2816 41.1603 38.3722 40.5774 39.5596 40.3412C40.7469 40.105 41.9777 40.2262 43.0962 40.6895C44.2146 41.1528 45.1706 41.9373 45.8432 42.9439C46.5158 43.9505 46.8748 45.134 46.8748 46.3446C46.8748 47.968 46.2299 49.5249 45.082 50.6728C43.9341 51.8208 42.3771 52.4657 40.7537 52.4657Z" })
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_38213_5398",
				x1: 19.6231,
				y1: 19.4587,
				x2: 67.8645,
				y2: 39.9812,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0064FA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00E1FA"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_38213_5398",
				x1: 37.1736,
				y1: 10.0073,
				x2: 55.1125,
				y2: 19.2018,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0064FA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#00E1FA"
				})]
			})
		] })
	]
});
export default SvgIconAddToAList;
